import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component( {
    selector: 'his-heading',
    templateUrl: './his-heading.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class HisHeadingComponent {
    @Input() level: number = 1;
    @Input() value: string = '';
}
